<template lang="pug">
  button.button(v-if="disabled" type="button" :class="classes" :style="styles" disabled)
    slot
  button.button(v-else-if="submit" type="submit" :class="classes" :style="styles" @click="$emit('click')")
    slot
  router-link.button(v-else-if="to" :to="to" :class="classes" :style="styles")
    slot
  label.button(v-else-if="label" :class="classes" :style="styles")
    slot
  a.button(v-else-if="href" :class="classes" :style="styles" :href="href" v-bind="$attrs" @click="$emit('click')")
    slot
  button.button(v-else type="button" :class="classes" :style="styles" @click="$emit('click')")
    slot
</template>

<script>
export default {
  name: 'BaseButton',
  props: {

    block: Boolean, // ?

    to: Object,
    href: String,
    submit: Boolean,
    label: Boolean,

    blue: Boolean,
    green: Boolean,
    dark: Boolean,
    grey: Boolean,
    violent: Boolean,

    xl: Boolean,
    lg: Boolean,
    md: Boolean,
    sm: Boolean,
    xs: Boolean,

    round: Boolean,
    narrow: Boolean,
    transparent: Boolean,
    disabled: Boolean,
    stretch: Boolean,
  },
  methods: {
    findValue(variants, defaultValue) {
      return Object.entries(variants).find(([, v]) => !!v)?.[0] ?? defaultValue;
    },
  },

  computed: {
    color() {
      const { blue, dark, grey, green, violent } = this; // eslint-disable-line
      return this.findValue({ blue, dark, grey, green, violent }, 'blue'); // eslint-disable-line
    },
    colors() {
      const colors = {
        //         main       hover      shadow     text      transparent
        blue:    ['#33A1FB', '#6BBCFF', '#3C95DE', '#FFFFFF', '#33A1FB'], // eslint-disable-line
        dark:    ['#1E3147', '#304D6E', '#1E3147', '#FFFFFF', '#1E3147'], // eslint-disable-line
        grey:    ['#E2E5E9', '#F8F9FC', '#1E3147', '#8B8CA9', '#8B8CA9'], // eslint-disable-line
        green:   ['#5AC169', '#6BCA79', '#6BCA79', '#FFFFFF', '#5AC169'], // eslint-disable-line
        violent: ['#99A3C5', '#B1BCDE', '#1E3147', '#FFFFFF', '#99A3C5'], // eslint-disable-line
      };

      return colors[this.color] ?? colors.blue;
    },

    size() {
      const { xl, lg, md, sm, xs } = this; // eslint-disable-line
      return this.findValue({ xl, lg, md, sm, xs }, 'md'); // eslint-disable-line
    },
    sizes() {
      const sizes = {
        //   height     fontSize      fontWeight    gap       padding-wide      padding-narrow
        xl: ['46px',    '16px',       700,          '13px',   '30px',           '20px', ], // eslint-disable-line
        lg: ['40px',    '16px',       700,          '13px',   '25px',           '20px', ], // eslint-disable-line
        md: ['34px',    '16px',       700,          '10px',   '25px',           '15px', ], // eslint-disable-line
        sm: ['28px',    '14px',       700,          '10px',   '20px',           '12px', ], // eslint-disable-line
        xs: ['22px',    '11px',       700,          '5px',    '20px',           '12px', ], // eslint-disable-line
      };

      return sizes[this.size] ?? sizes.md;
    },
    cssVars() {
      return {
        '--color-main':         this.colors[0], // eslint-disable-line
        '--color-hover':        this.colors[1], // eslint-disable-line
        '--color-shadow':       this.colors[2], // eslint-disable-line
        '--color-text':         this.colors[3], // eslint-disable-line
        '--color-transparent':  this.colors[4], // eslint-disable-line
        '--height':             this.sizes[0], // eslint-disable-line
        '--font-size':          this.sizes[1], // eslint-disable-line
        '--font-weight':        this.sizes[2], // eslint-disable-line
        '--gap':                this.sizes[3], // eslint-disable-line
        '--padding-wide':       this.sizes[4], // eslint-disable-line
        '--padding-narrow':     this.sizes[5], // eslint-disable-line
      };
    },
    styles() { return this.cssVars; },
    classes() {
      const  { block, round, narrow, transparent, stretch } = this; // eslint-disable-line
      return { block, round, narrow, transparent, stretch }; // eslint-disable-line
    },
  },
};
</script>

<style scoped lang="scss">
.button {
  height: var(--height);
  box-sizing: border-box;
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  line-height: 1.2;
  text-align: center;

  transition: box-shadow 0.05s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, top 0.1s ease-in-out;
  color: var(--color-text);

  display: inline-flex;
  &.block { display: flex; }

  justify-content: center;
  align-items: center;
  gap: var(--gap);

  padding: 0 var(--padding-wide);
  &.narrow { padding: 0 var(--padding-narrow); }

  border-radius: 4px;
  &.round { border-radius: 22px; }

  cursor: pointer;
  position: relative;
  top: 0;

  &.stretch {
    width: 100%;
  }

  &[disabled] {
    opacity: .5;
    cursor: not-allowed;
  }

  background: var(--color-main);
  border: 1px solid var(--color-main);

  &:hover:not([disabled]) {
    top: -2px;
    background: var(--color-hover);
    border: 1px solid var(--color-hover);
    box-shadow: 0 10px 10px -10px var(--color-shadow);
  }

  &:hover:active:not([disabled]) {
    top: -1px;
    box-shadow: 0 9px 10px -10px var(--color-shadow);
    background: var(--color-main);
    border: 1px solid var(--color-main);
  }

  &.transparent {
    border: 1px solid var(--color-transparent) !important;
    color: var(--color-transparent) !important;
    background: none !important;
  }
}
</style>
